import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SelectControl, SelectItem } from 'src/app/form-controls/select/select.control';
import { UnitQuantity, UnitQuantityControl } from 'src/app/form-controls/unit-quantity/unit-quantity.control';
import { SheetItemService } from 'src/app/services/sheet-item.service';
import { ItemTypeMetadata, SheetItemFormBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { FluidsSubcutaneousInstruction, FluidsSubcutaneousMedicationRoute } from 'src/app/types/sheet-instruction.types';
import { InstructionsFormComponent } from '../../instructions-form/instructions-form.component';

interface FluidsSubcutaneousInstructionFormGroup {
	volume: FormControl<UnitQuantity | null>;
	medicationRoute: FormControl<FluidsSubcutaneousMedicationRoute | null>;
}

@Component({
    selector: 'app-fluids-subcutaneous-item-form',
    templateUrl: './fluids-subcutaneous-item-form.component.html',
    styleUrl: './fluids-subcutaneous-item-form.component.scss',
    imports: [ReactiveFormsModule, InstructionsFormComponent, UnitQuantityControl, SelectControl],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FluidsSubcutaneousItemFormComponent implements SheetItemFormBase, OnInit {

	@Input() instructionTypeName!: string;
	@Input() item!: Row | null;
	@Input() minDate!: string;
	@Input() maxDate!: string;
	@Input() instructionsFormArray!: FormArray;
	@Input() itemConfig!: ItemTypeMetadata;

	medicationRoutes: SelectItem[] = [
		{ text: 'Subcutaneous', value: FluidsSubcutaneousMedicationRoute.Subcutaneous }
	];

	constructor(private sheetItemService: SheetItemService, private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.sheetItemService.getInstructions(this.item, this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency).forEach(instruction => {
			const group: FormGroup<FluidsSubcutaneousInstructionFormGroup> = this.sheetItemService.buildExistingInstructionGroup(this.instructionTypeName, instruction);
			const FluidsSubcutaneousInstruction = instruction as FluidsSubcutaneousInstruction;
			group.addControl('volume', this.formBuilder.control(FluidsSubcutaneousInstruction.volume ?? null));
			group.addControl('medicationRoute', this.formBuilder.control(FluidsSubcutaneousMedicationRoute.Subcutaneous));
			this.instructionsFormArray.push(group);
		});
	}

	addInstruction() {
		const group: FormGroup<FluidsSubcutaneousInstructionFormGroup> = this.sheetItemService.getNewInstructionGroup(this.instructionTypeName, this.itemConfig.scheduleConfig.defaultScheduleType, this.itemConfig.scheduleConfig.defaultRepeatingScheduleFrequency);
		group.addControl('volume', this.formBuilder.control(null));
		group.addControl('medicationRoute', this.formBuilder.control(FluidsSubcutaneousMedicationRoute.Subcutaneous));
		this.instructionsFormArray.push(group);
	}
}